import { BannersController } from './features/banners/controller.js?v=1';
import { ItemsController } from './features/items/controller.js?v=1';
import { UserPrivateController } from './features/user-private/controller.js?v=2';
import { StarsController } from './components/stars.js?v=1';
import { UserPublicController } from './features/user-public/controller.js?v=1';
import { Buttons } from './components/buttons.js';
import { LoadingDot } from './components/loading-dot.js';
import { USER_OPTIONS } from './config/constants.js';


class App {
  constructor() {
    // this.authController = new AuthController();
    this.buttons = new Buttons();
    this.loadingDot = LoadingDot.getInstance();
    this.itemsController = new ItemsController();
    this.userPrivateController = new UserPrivateController();
    this.userPublicController = new UserPublicController();
    // this.searchController = new SearchController();
    this.bannerController = BannersController.getInstance();
    this.starsController = StarsController.getInstance();
  }


  init() {
    if (APICRUD) {
      this.setupRouter();
      this.bindGlobalEvents();
      this.bannerController.init();
    } else {
      setTimeout(this.init.bind(this), 1000);
    }
  }

  setupRouter() {
    const path = window.location.pathname;

    if (path.startsWith('/mercadopago')) {
      // DONE: redireccionar a ventana de verificación de estado de plan.
      window.app.userPrivateController.account.subscriptions.showPlanStatus();
      APICRUD.Token = 'W3i8cCUg9uNs8Kq3W85Ru9fP1cP16D';
      APICRUD.OnLoadEnd = () => {
        this.itemsController.init();
        APICRUD.MercadoPago.Subscriptions.SetPaymentIntent();
      };
    } else if (path.startsWith('/user')) {
      APICRUD.Token = '1QPZ5l1ktk6m8m5L4Xr8n6Fg547Q1e';
      APICRUD.OnLoadEnd = this.userPrivateController.checkSession.bind(this.userPrivateController);
    }
    else if (path.startsWith('/registration')) {
      APICRUD.Token = 'A19QgkA2Z8H80WC13rU304Ara4FQX2';
      APICRUD.OnLoadEnd = () => {
        document.getElementById('content').innerHTML = this.userPrivateController.auth.view.renderRegister();
        APICRUD.Location.Selector_LoadStates('register-idState', '5', '0');
        APICRUD.Location.Selector_LoadCities('register-idCity', '0', '0');
        APICRUD.Common.Select.SetData('register-occupation', '', USER_OPTIONS.Cargos);
        this.userPrivateController.checkSession();
      };
    }
    else if (path.startsWith('/activation')) {
      APICRUD.Token = 'A19QgkA2Z8H80WC13rU304Ara4FQX2';
      const query = path.replace('/activation/', '');
      APICRUD.OnLoadEnd = () => {
        this.userPrivateController.auth.activation(query);
        this.userPrivateController.checkSession();
      };
    }
    else if (path.startsWith('/search')) {
      APICRUD.Token = 'W3i8cCUg9uNs8Kq3W85Ru9fP1cP16D';
      APICRUD.OnLoadEnd = () => {
        const query = path.replace('/search/', '').replace(/-/g, ' ');
        // Rellenamos los inputs de búsqueda con el término actual
        document.getElementById('search-input').value = query;
        document.getElementById('search-input-mobile').value = query;

        this.itemsController.search(query);
        this.userPrivateController.checkSession();
      };
    }
    else if (path.startsWith('/productos/') || path.startsWith('/maquinaria/') || path.startsWith('/inmuebles/') || path.startsWith('/servicios/')) {
      APICRUD.Token = 'W3i8cCUg9uNs8Kq3W85Ru9fP1cP16D';
      APICRUD.OnLoadEnd = () => {
        const query = path
          .replace('/productos/', '')
          .replace('/maquinaria/', '')
          .replace('/inmuebles/', '')
          .replace('/servicios/', '')
          .replace(/-/g, ' ').split('/');

        this.itemsController.showItemDetail(query[0], query[1]);
        this.userPrivateController.checkSession();
      };
    }
    else if (path.startsWith('/perfil/')) {
      APICRUD.Token = 'W3i8cCUg9uNs8Kq3W85Ru9fP1cP16D';
      APICRUD.OnLoadEnd = () => {
        const query = path
          .replace('/perfil/', '').split('/');

        this.userPublicController.show(query[0]);
        this.userPrivateController.checkSession();
      };
    } else { // Homepage y otras páginas
      APICRUD.Token = 'W3i8cCUg9uNs8Kq3W85Ru9fP1cP16D';
      APICRUD.OnLoadEnd = () => {
        if (path === '/' || path === '/home') {
          this.itemsController.init(null, '');
        } else if (path === '/productos' || path === '/productos/') {
          this.itemsController.init(null, 'producto', 'Productos');
        } else if (path === '/maquinaria' || path === '/maquinaria/') {
          this.itemsController.init(null, 'maquina', 'Maquinaria');
        } else if (path === '/inmuebles' || path === '/inmuebles/') {
          this.itemsController.init(null, 'inmueble', 'Inmuebles');
        } else if (path === '/servicios' || path === '/servicios/') {
          this.itemsController.init(null, 'servicio', 'Servicios');
        }
        this.userPrivateController.checkSession();
      };
    }
  }

  bindGlobalEvents() {
    const header = document.getElementById('header');
    window.addEventListener('scroll', () => {
      if (!header) return;
      header.className = (window.scrollY > 30) ? 'active' : '';
    });
  }
}

// Iniciar la aplicación cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', () => {
  window.app = new App();
  app.init();
});

window.InitButtonToProvider = function () {
  const scrollButton = document.getElementById('scrollToBottomButton');
  const targetElement = document.getElementById('datosDelProveedor');

  const isElementApproaching = (element) => {
    const rect = element.getBoundingClientRect();
    // Retorna true si la parte superior del elemento está dentro de la ventana de visualización
    return rect.top <= (window.innerHeight || document.documentElement.clientHeight);
  };

  // Función para manejar la visibilidad del botón
  const handleScroll = () => {
    if (isElementApproaching(targetElement)) {
      scrollButton.style.display = 'none'; // Oculta el botón
    } else {
      scrollButton.style.display = 'block'; // Muestra el botón
    }
  };

  // Función para hacer scroll al elemento
  const scrollToTarget = () => {
    targetElement.scrollIntoView({
      behavior: 'smooth'
    });
  };

  // Evento de click para el botón de salto
  scrollButton.addEventListener('click', scrollToTarget);

  // Evento de scroll para el documento
  window.addEventListener('scroll', handleScroll);

  // Llamada inicial para establecer el estado del botón al cargar la página
  handleScroll();
}
